module.exports = __webpack_public_path__ + "static/media/ic_aadhaar_card.7fe20db8.svg";